import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

export const PermissionsService = {
  // Auth's catalogue of grantable permissions, readable by any signed-in user.
  getPermissions() {
    return ApiService.get(`${Config.api.auth.url}permissions`).then((response) => response.data);
  },
};
